// initial state
import * as base from './base.js'
const baseName = '/admin/system/config'


const configure = baseName + '/list'



const obj = base.setBaseUrl('configure', baseName)



const a = Object.assign(obj,{configure,})
export default a